import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const Licitante = () => {
  const wpp = generateWhatsAppLink('licitante', 'licitante-page');
  return (
    <div>
      <Helmet>
        <title>Luminárias de LED para Licitações | Sustenta LED</title>
        <meta name="description" content="Distribuidora e representante de LED para licitações públicas. Suporte técnico, especificações e documentação conforme normas." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>Luminárias de LED para Licitações</h1>
              <p>Atendemos órgãos públicos e processos licitatórios com produtos homologados, especificações técnicas e documentação completa. Somos atacadistas, distribuidores e representantes, com soluções para iluminação pública, prédios e áreas externas.</p>
              <p>Auxiliamos na escolha de modelos conforme edital, normas e critérios de eficiência. Oferecemos suporte técnico e comercial para propostas e execução.</p>
              <p>Conte com nossa experiência e estoque nacional para atender demandas de licitações com segurança e qualidade.</p>
              <div className="d-flex flex-column align-items-start">
                <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                  Solicite agora a sua cotação e receba em até 1h
                </a>
                <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                  Voltar à página anterior
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/clientes/banner_licitante.jpg" alt="Luminárias de LED para Licitações - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Licitante;
